import { render } from "./ClockComponent.vue?vue&type=template&id=0532dd1f"
import script from "./ClockComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClockComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClockComponent.vue?vue&type=style&index=0&id=0532dd1f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__